/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_List_Title_TailInputs */

const en_pricing_list_title_tail = /** @type {(inputs: Pricing_List_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no asterisks`)
};

const pl_pricing_list_title_tail = /** @type {(inputs: Pricing_List_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bez gwiazdek`)
};

/**
* | output |
* | --- |
* | "no asterisks" |
*
* @param {Pricing_List_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_list_title_tail = /** @type {((inputs?: Pricing_List_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_List_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_list_title_tail(inputs)
	return en_pricing_list_title_tail(inputs)
});